import React, {useState, useEffect} from "react";
import { NavLink, Link } from "react-router-dom";
import NAVBARLIST from "../../db/navBarMenuList";
import DOCUMENT_SUBMENU_LIST from "../../db/documentSubMenuList";
import style from "../header/style.module.css"

const Header = () => {

  const menus = Object.keys(NAVBARLIST); //extract the menu names from the NAVBARLIST object
  const documentSubMenus = Object.keys(DOCUMENT_SUBMENU_LIST);

  const [scrolled, setScrolled] = useState(false);

  //define useeffect to add the scroll event listener and handle accordingly
  useEffect(()=> {

    //defined Event Handler for mouse scroll
    const handleScroll = () => {
      setScrolled(window.scrollY >= 112)
    };
    //Add event handler for scroll
    window.addEventListener('scroll', handleScroll);

    //cleanup function
    return () => window.removeEventListener('scroll', handleScroll);
  },[]);

  //define a function for the pdf documents

  const pdfDocument = (e) => {
    e.preventDefault();
    const filename = e.target.getAttribute("data-value");
    const pdfPath = `./documents/${filename}`; // Path to PDF in public folder
    window.open(pdfPath, '_blank'); // Opens in new tab
  };

 
  return (
    <>
      {/* Heading content "#fafaf2" #d5d5cd #d9d9d2  #f2f2fa #f3f3e0 #e5e5bb #ececcd*/}
      {/* "#ececcd" */}
      <section>
      <div className="d-flex p-1 gap-1 align-items-center justify-content-between" style={{backgroundColor:"#edf7f8"}}> 
        {/* <h3 >We are K-PALS UK</h3> */}
        <Link to={NAVBARLIST.Home}>
              <img
                src="../img/logo-kpals.png"
                alt="K-PALS UK"
                //height="100rem"
                className={style.headLogo} 
              />
        </Link>
        <h1 className="text-center d-none d-lg-block d-xl-block" style={{color:"#018d36",fontWeight:"bold"}}>Kathmandu Institute of Child Health Pals UK</h1>
        <h6 className="align-self-end" style={{color:"#089fe4"}}>Charity Regd. No. 1209691</h6>
        {/* <Link to={NAVBARLIST.Home}>
              <img
                src="../img/partners/facebook-1.png"
                alt="facebook"
                style={{maxWidth:"50px",maxHeight:"50px"}}
                 
              />
        </Link>        */}
      </div>        
      </section>
      {/* Heading content ends */}


      {/* Navbar starts.. */}
      <section className="sticky-top">
        <nav className="navbar navbar-expand-lg navbar-dark bg-transparent sticky-top py-0 mb-0">
          <div className="container-fluid" style={{backgroundColor: "#059ee2"}}>
            {/* <!-- style is used to add the navbar color as per requirement-->
              <!-- Logo --> */}
            <Link className="navbar-brand fs-4 " to={NAVBARLIST.Home}>
              <img
                src="../img/logo-kpals.png"
                alt="K-PALS UK"
                //height="100rem"
                className= {!scrolled ? style.logoImg : style.logoImgScrolled }            
              />
            </Link>
            {/* <!-- Toggle Button --> */}
            <button
              className="navbar-toggler shadow-none border-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            {/* <!-- SideBar --> */}
            <div
              className= {`${style.sidebar} offcanvas offcanvas-start`}
              tabindex="-1"
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              {/* <!-- SideBar Header --> */}
              <div className="offcanvas-header text-white border-bottom">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  <img src="../img/logo-kpals.png" alt="K-PALS UK" height="60rem"
              />
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white shadow-none"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"                  
                ></button>
              </div>
              {/* <!-- SideBar Body --> */}
              <div className="offcanvas-body d-flex flex-column flex-lg-row">
                {/* <!-- p-lg-2 is used to determine the height of navbar --> */}
                <ul className={`navbar-nav justify-content-center align-items-start align-items-lg-center fs-5 flex-grow-1 px-3`}>
                  {menus.map(item => {
                      return (
                          <li className="nav-item mx-2 p-2" >
                              <NavLink className={({ isActive }) => isActive ? `${style.navLinkStyle} ${style.active}` : `${style.navLinkStyle}`} to = {NAVBARLIST[item]}>{item}</NavLink>
                          </li>
                      );
                  })}

                  {/* Document Menu and SubMenus */}
                  <li className= {`nav-item dropdown mx-2 py-2 px-4 bg-transparent ${style.submenu}`}>
                    <a className={`nav-link dropdown-toggle ${style.dropdown}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Documents
                    </a>
                    <ul className= {`dropdown-menu ${style.submenu} `} >
                      {documentSubMenus.map(item => {
                        return (                          
                          <li>
                            <a className={`dropdown-item ${style.submenu}`} href="#" data-value={DOCUMENT_SUBMENU_LIST[item]} onClick={pdfDocument}>{item}</a>
                          </li>
                        );
                      })}                     
                    </ul>
                  </li>
                  {/* End of Document Menu and SubMenus */}

                  <li>
                    <div className="donate-button px-4">
                      <a href="https://justgiving.com/kpals" target="_blank" rel="noreferrer" className="btn btn-danger btn-lg" role="button" aria-pressed="true" ><p style={{color:"white", fontWeight:"bold"}}>Donate Now</p></a>
                    </div>
                  </li>               
                
                </ul>

                {/* <!-- Login / Sign-up --> */}
                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center gap-3" >
                  <a href="#login" className="text-white" style={{display:"none"}}>
                    Login
                  </a>
                  <a
                    href="#signup"
                    className="text-white text-decoration-none px-3 py-1 rounded-4"
                    style={{backgroundColor: "#f94ca4", display:"none"}}
                  >
                    Sign-up
                  </a>
                </div>
              </div>
            </div>
          </div>       
        </nav>
      </section>      
      {/* <hr className={style.goldLine} /> */}


    </>
  );
};

export default Header;
